import {
  Datagrid,
  TextField,
  useTranslate,
  FunctionField,
  EditButton,
} from "react-admin";
import { JsonField } from "react-admin-json-view";
import {
  DateField,
  CreateOnlyTopToolbar,
  CustomList,
} from "../../shared/components/index.js";

const EmailServiceList = () => {
  const t = useTranslate();

  return (
    <CustomList actions={<CreateOnlyTopToolbar />}>
      <Datagrid rowClick={false} bulkActionButtons={false}>
        <TextField source="name" />
        <JsonField
          label="resources.EmailService.fields.config.name"
          source="config"
          reactJsonOptions={{
            name: null,
            collapsed: true,
            enableClipboard: false,
            displayDataTypes: false,
          }}
          sortable={false}
        />
        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.EmailService.source.status.${record.status}`)
          }
        />
        <DateField source="created_at" />
        <DateField source="updated_at" />
        <EditButton className="button-edit" />
      </Datagrid>
    </CustomList>
  );
};

export default EmailServiceList;
